import { React } from '../libraries'

export const Page404 = () => {
    return (
        <>
            <div className="flex h-screen page-404">
                <div className="m-auto text-center">
                    <h1 className="text-5xl mb-5">Page 404</h1>
                    <p>Oops! Something is wrong.</p>
                </div>
            </div>
        </>
    );
}